import { Link } from 'react-router-dom';
import type { DoujinWork } from '@/mocks/doujin';

const statusStyles: Record<string, string> = {
  连载中: 'bg-primary-100 text-primary-800',
  汉化完成: 'bg-secondary-100 text-secondary-900',
  即将开坑: 'bg-accent-100 text-accent-800',
};

export default function WorkCard({ work }: { work: DoujinWork }) {
  return (
    <article className="group bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-200 transition-colors flex flex-col">
      <Link to={`/article/${work.slug}`} className="block relative overflow-hidden aspect-[4/5]">
        <img
          src={work.cover}
          alt={`${work.title}封面`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-medium ${statusStyles[work.status]}`}
        >
          {work.status}
        </span>
        <span className="absolute bottom-3 right-3 flex items-center gap-1 px-2 py-1 rounded-full bg-background-950/70 text-background-100 text-xs">
          <i className="ri-eye-line"></i>
          {(work.views / 1000).toFixed(1)}k
        </span>
      </Link>
      <div className="p-4 flex flex-col flex-1">
        <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 leading-snug">
          <Link to={`/article/${work.slug}`} className="hover:text-primary-700 transition-colors">
            {work.title}
          </Link>
        </h3>
        <p className="mt-1.5 text-xs text-foreground-500 line-clamp-2 leading-relaxed">{work.summary}</p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {work.tags.slice(0, 3).map((t) => (
            <span key={t} className="px-2 py-0.5 rounded bg-background-100 text-foreground-500 text-xs">
              #{t}
            </span>
          ))}
        </div>
        <div className="mt-4 pt-3 border-t border-background-100 flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {work.updateTime}
          </span>
          <span className="flex items-center gap-1 text-foreground-600">
            <i className="ri-book-3-line"></i>
            {work.latestChapter}
          </span>
        </div>
      </div>
    </article>
  );
}